//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.util')
        .factory('notificationService', notificationService);


    function notificationService(NotificationResource, $q) {

        var service = {};

        service.requestGrant = function (id) {
            var d = $q.defer();

            NotificationResource.requestGrant({id: id}, function (response) {
                    console.log("successfully requested grant with response: ", response);
                    d.resolve(response);
                    return;
                }, function (error) {
                    console.log("requested grant with following error: ", error);
                    d.reject(error);
                    return;
                });
            return d.promise;
        };

        service.requestMultipleGrants = function (ids) {
            var d = $q.defer();

            NotificationResource.requestMultipleGrants({}, ids, function (response) {
                    console.log("successfully requested grants with response: ", response);
                    d.resolve(response);
                    return;
                }, function (error) {
                    console.log("requested grants with following error: ", error);
                    d.reject(error);
                    return;
                });
            return d.promise;
        };

        return service;

    }


})();